import React from 'react';
import { AIProvider } from '../ai';

const LABELS: Record<AIProvider, { text: string; color: string; background: string }> = {
  claude: { text: 'Claude', color: '#9a3412', background: '#ffedd5' },
  gemini: { text: 'Gemini', color: '#1e40af', background: '#dbeafe' },
  pollinations: { text: 'Pollinations', color: '#475569', background: '#e2e8f0' },
};

const ProviderBadge: React.FC<{ provider?: AIProvider }> = ({ provider }) => {
  if (!provider) return null;
  const label = LABELS[provider];
  return (
    <span
      title={`Generated by ${label.text}`}
      style={{
        fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '999px',
        color: label.color, backgroundColor: label.background, whiteSpace: 'nowrap',
      }}
    >
      {label.text}
    </span>
  );
};

export default ProviderBadge;
